import { Navigate } from 'react-router-dom'
import { usePermissions } from '../auth/usePermissions'

/** `/` → Ask（方針 A）。search 無しは作業台、それ以外は forbidden。 */
export function RootRedirect() {
  const { canSearch, canCurate, canApprove } = usePermissions()

  if (canSearch) {
    return <Navigate to="/rag/chat" replace />
  }
  if (canCurate || canApprove) {
    return <Navigate to="/rag/documents" replace />
  }
  return <Navigate to="/forbidden" replace />
}
